import store from './store';
import {logIn, fetchFeedPosts, fetchCurrentUserPosts, fetchAllUsers} from './actions';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";


store.subscribe(() => {
    //console.log("Store Updated", store.getState());
})

export function index() {
    firebase.firestore()
    .collection('users')
    .doc(firebase.auth().currentUser.uid)
    .get()
    .then((snapshot) => {
        if(snapshot.exists){
            store.dispatch(logIn(snapshot.data()));
            //console.log(snapshot.data())
        } else {
            //console.log('does not exist')
        }
    })
}
export function loadFeedPosts() {
    const feedPosts = [];

    firebase.firestore()
    .collection('users')
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            //console.log(doc.data(), doc.id)
            const userImage = doc.data().image
            const userRole = doc.data().role
            firebase.firestore()
            .collection('posts')
            .doc(doc.id)
            .collection('userPosts')
            .orderBy('creation', 'desc') //temporary, observe how it acts
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    const feedObject = {}
                    //console.log(doc.data(), doc.id)
                    feedObject['posterRole'] = userRole
                    feedObject['postTitle'] = doc.data().title
                    feedObject['postMessage'] = doc.data().message
                    feedObject['postURL'] = doc.data().downloadURL 
                    feedObject['posterId'] = doc.data().posterId 
                    feedObject['likes'] = doc.data().likes
                    feedObject['saves'] = doc.data().saves
                    feedObject['shares'] = doc.data().shares
                    feedObject['postId'] = doc.id
                    feedObject['posterName'] = doc.data().posterName
                    feedObject['posterImage'] = userImage
                    const timestamp = doc.data().creation;
                    const timePosted = timestamp.toDate();
                    feedObject['timePosted'] = timePosted                
                    feedPosts.push(feedObject); 
                });
                store.dispatch(fetchFeedPosts(feedPosts));
            })
            .catch((error) => {
                //console.log('Error getting user posts:', error);
            });
        });
    })
    .catch((error) => {
        //console.log('Error getting documents:', error);
    });
}
export function loadCurrentUserPosts() {
    const currentUserPosts = [];
    firebase.firestore()
    .collection('posts')
    .doc(firebase.auth().currentUser.uid)
    .collection('userPosts')
    .orderBy('creation', 'desc') //temporary, observe how it acts
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {    
            //currentUserPosts.push(doc.data());
            const feedObject = {}
            feedObject['postTitle'] = doc.data().title
            feedObject['postMessage'] = doc.data().message
            feedObject['postURL'] = doc.data().downloadURL 
            feedObject['posterId'] = doc.data().posterId
            feedObject['likes'] = doc.data().likes
            feedObject['saves'] = doc.data().saves
            feedObject['shares'] = doc.data().shares         
            feedObject['postId'] = doc.id
            const timestamp = doc.data().creation;
            const timePosted = timestamp.toDate();
            feedObject['timePosted'] = timePosted   

            firebase.firestore()
            .collection('users')
            .doc(doc.data().posterId)
            .get()
            .then((snapshot) => {
                if(snapshot.exists){
                    //console.log(snapshot.data())
                    feedObject['posterName'] = doc.data().name 
                } else {
                    //console.log('does not exist')
                }
            })
            currentUserPosts.push(feedObject); 
            //console.log(doc.data()) 
        });
    store.dispatch(fetchCurrentUserPosts(currentUserPosts));
    })
    .catch((error) => {
        //console.log('Error getting current user posts:', error);
    });
}

export function loadAllUsers() {
    const allUsers = []
    firebase.firestore()
    .collection('users')
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            const users = { ...doc.data(), userId: doc.id };
            allUsers.push(users)
        }
    )});
    store.dispatch(fetchAllUsers(allUsers))
}